import {
    PostCheckoutMandatoryCustomQuestionsVariant,
    PostCheckoutMandatoryQuestionsInAppVariant,
} from '../../constants/statsig/types';
import { CheckoutState } from '../../state';
import { isPostCheckoutMandatoryQuestionsElegible } from '../postCheckoutMandatoryQuestions/isPostCheckoutMandatoryQuestionsElegible';
import {
    getCannedAndOptionalQuestionsForAttendees,
    getOptionalQuestionsForAttendees,
    getQuestionsForAttendees,
} from './attendees';
import { getQuestionsForBuyer } from './buyer';
import { getCannedAndOptionalQuestionsForBuyer } from './getCannedAndOptionalQuestionsForBuyer';
import { getOptionalQuestionsForBuyer } from './getOptionalQuestionsForBuyer';

export const isOrderFormSplittedInTwoPages = (
    state: CheckoutState,
    statsigExperimentVariant:
        | PostCheckoutMandatoryCustomQuestionsVariant
        | PostCheckoutMandatoryQuestionsInAppVariant,
): boolean => {
    if (
        [
            PostCheckoutMandatoryCustomQuestionsVariant.customQuestions,
            PostCheckoutMandatoryQuestionsInAppVariant.customQuestionsInApp,
        ].includes(statsigExperimentVariant)
    ) {
        const attendeeSurveys = getQuestionsForAttendees(state);
        const questions = [
            ...attendeeSurveys.flatMap(
                (attendeeSurvey) => attendeeSurvey.survey,
            ),
            ...getQuestionsForBuyer(state),
        ];
        return questions.length > 0;
    }

    if (
        isPostCheckoutMandatoryQuestionsElegible(state) ||
        statsigExperimentVariant ===
            PostCheckoutMandatoryQuestionsInAppVariant.optionalAndCannedQuestionsInApp
    ) {
        const attendeeSurveys =
            getCannedAndOptionalQuestionsForAttendees(state);
        const questions = [
            ...attendeeSurveys.flatMap(
                (attendeeSurvey) => attendeeSurvey.survey,
            ),
            ...getCannedAndOptionalQuestionsForBuyer(state),
        ];
        return questions.length > 0;
    }

    const attendeeSurveys = getOptionalQuestionsForAttendees(state);
    const questions = [
        ...attendeeSurveys.flatMap((attendeeSurvey) => attendeeSurvey.survey),
        ...getOptionalQuestionsForBuyer(state),
    ];
    return questions.length > 0;
};
